<mat-sidenav-container>

    <div id="wtf-main-content">

        <!-- TOOLBAR: Above -->
        <ng-container *ngIf="wtfSettings.layout.toolbar === 'above'">
            <wtf-toolbar class="above" [ngClass]="wtfSettings.colorClasses.toolbar"></wtf-toolbar>
        </ng-container>
        <!-- / TOOLBAR: Above -->





        <!-- NAVBAR: Top -->
        <wtf-navbar-horizontal class="top-navbar" fxHide fxShow.gt-md [ngClass]="wtfSettings.colorClasses.navbar"
            *ngIf="wtfSettings.layout.navigation === 'top'">
        </wtf-navbar-horizontal>
        <!-- / NAVBAR: Top -->

        <div id="wrapper">

            @if (toolbarDisplay) {
            <!-- NAVBAR: Left -->
            <wtf-navbar-vertical [folded]="wtfSettings.layout.navigationFolded" class="left-navbar"
                [ngClass]="wtfSettings.colorClasses.navbar" *ngIf="wtfSettings.layout.navigation === 'left'">
            </wtf-navbar-vertical>
            <!-- / NAVBAR: Left -->
            }


            <div class="content-wrapper">


                <!-- TOOLBAR: Below -->
                <ng-container *ngIf="wtfSettings.layout.toolbar === 'below'">
                    <wtf-toolbar class="below" [ngClass]="wtfSettings.colorClasses.toolbar"></wtf-toolbar>
                </ng-container>
                <!-- / TOOLBAR: Below -->



                <wtf-content id="maincontent"></wtf-content>

                <!-- FOOTER: Below -->
                <ng-container *ngIf="wtfSettings.layout.footer === 'below'">
                    <wtf-footer class="below" [ngClass]="wtfSettings.colorClasses.footer"></wtf-footer>
                </ng-container>
                <!-- / FOOTER: Below -->

            </div>

            @if (toolbarDisplay) {
            <!-- NAVBAR: Right -->
            <wtf-navbar-vertical [folded]="wtfSettings.layout.navigationFolded" class="right-navbar"
                [ngClass]="wtfSettings.colorClasses.navbar" *ngIf="wtfSettings.layout.navigation === 'right'">
            </wtf-navbar-vertical>
            <!-- / NAVBAR: Right -->
            }


        </div>

        <!-- FOOTER: Above -->
        <ng-container *ngIf="wtfSettings.layout.footer === 'above'">
            <wtf-footer class="above" [ngClass]="wtfSettings.colorClasses.footer"></wtf-footer>
        </ng-container>
        <!-- FOOTER: Above -->

    </div>
    <!-- -->
    <!-- QUICK PANEL -->
    <mat-sidenav position="end">
        <wtf-quick-panel></wtf-quick-panel>
    </mat-sidenav>
    <!-- / QUICK PANEL -->

</mat-sidenav-container>

<!-- <wtf-theme-options></wtf-theme-options>  -->